import React from "react";
import HeaderMain from "../Header/HeaderMain";
import FooterMain from "../Footer/FooterMain";
import ScrollToTop from "../ScrollToTop/ScrollToTop";
import WhatsAppButton from "../Whatsapp/WhatsappButton";
import SuccessStories from "./SuccessStory";
import Engagements from "./Engagements";
import FAQSection from "../FAQ/FAQSection";

/**
 * The /success page.
 *
 * The route previously rendered the bare <SuccessStory> section with no header
 * and no footer, so the page had zero links in or out — an orphan as far as a
 * crawler is concerned, and a dead end for anyone who landed on it.
 */
const SuccessMain = () => {
  return (
    <>
      <HeaderMain />
      <main>
        <SuccessStories headingLevel="h1" />
        <Engagements />
        <FAQSection />
      </main>
      <FooterMain />
      <ScrollToTop />
      <WhatsAppButton />
    </>
  );
};

export default SuccessMain;
